import React from "react";

import { Select } from "@shared/selects";

import { WindowSizeDays, type IWindowSizeDays } from "./use-report-body-state";

interface WindowSizeDaysSelectProps {
  isLoading: boolean;
  windowSizeDays: IWindowSizeDays;
  onChange: (obj: any) => void;
}

export function WindowSizeDaysSelect({
  isLoading,
  windowSizeDays,
  onChange,
}: WindowSizeDaysSelectProps) {
  return (
    <Select
      label="GROUP BY"
      isLoading={isLoading}
      value={windowSizeDays}
      options={WindowSizeDays.reactSelectOptions}
      onChange={onChange}
    />
  );
}
